import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import {DataProvider} from "../../providers/data/data";
import {Sector} from "../../models/data.model";

@IonicPage()
@Component({
  selector: 'page-list-routes-sector',
  templateUrl: 'list-routes-sector.html',
})
export class ListRoutesSectorPage {

  sectorId: number;
  siteId: number;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public data: DataProvider) {
    this.siteId = navParams.get('siteId');
    this.sectorId = navParams.get('sectorId');
  }

  protected getSector(): Sector {
    return this.data.getSector(this.siteId, this.sectorId);
  }

}



// WEBPACK FOOTER //
// ./src/pages/list-routes-sector/list-routes-sector.ts